const estadisticas = {
  salarioPromedio: true,
  posicionPostulante: false,
}

export default estadisticas
